import { render } from "./ComplimentaryFeaturesPage.vue?vue&type=template&id=df4d69ea&scoped=true"
import script from "./ComplimentaryFeaturesPage.vue?vue&type=script&lang=js"
export * from "./ComplimentaryFeaturesPage.vue?vue&type=script&lang=js"

import "./ComplimentaryFeaturesPage.vue?vue&type=style&index=0&id=df4d69ea&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4d69ea"]])

export default __exports__